import { ButtonGroup, TitleWithCounter } from 'src/components/atoms';
import { GlobalFilterLocation } from 'src/types';

interface Props {
  title: string;
  selectedOptions: string[];
  isGroupedLocationFilter?: boolean;
  selectedGroupedLocationFilter?: GlobalFilterLocation;
  setSelectedGroupedLocationFilter?: (location: GlobalFilterLocation) => void;
  'data-testid'?: string;
}

enum SelectedLocation {
  SITE = 'Site',
  COUNTRY = 'Country',
}

export const LocalFilterSectionTitle = ({
  title,
  selectedOptions,
  isGroupedLocationFilter,
  selectedGroupedLocationFilter,
  setSelectedGroupedLocationFilter,
  ...props
}: Props) => {
  const amountSelected = selectedOptions.length;
  const selectedLocation =
    selectedGroupedLocationFilter === GlobalFilterLocation.SITES
      ? SelectedLocation.SITE
      : SelectedLocation.COUNTRY;
  const selectedOptionWithCount = `${selectedLocation} (${amountSelected})`;
  const options = Object.values(SelectedLocation).map((key) => {
    if (selectedLocation === key) {
      return selectedOptionWithCount;
    }
    return key;
  });

  const handleLocationSelect = (location: string) => {
    if (setSelectedGroupedLocationFilter) {
      setSelectedGroupedLocationFilter(
        location === SelectedLocation.SITE
          ? GlobalFilterLocation.SITES
          : GlobalFilterLocation.COUNTRIES,
      );
    }
  };

  return (
    <>
      {isGroupedLocationFilter ? (
        <ButtonGroup
          options={options}
          selectedOption={selectedOptionWithCount}
          setSelectedOption={handleLocationSelect}
          buttonWidth="165px"
          buttonGroupOptionTestId="location-filter-button-group"
        />
      ) : (
        <TitleWithCounter
          title={title}
          counter={`${selectedOptions.length} selected`}
          data-testid={`${props['data-testid']}-title`}
        />
      )}
    </>
  );
};
